<div class="info-backdrop" (click)="close.emit()">
  <div class="info-modal" (click)="$event.stopPropagation()" *ngIf="content">
    <div class="info-header">
      <span class="info-title">
        {{ currLang === 'ar' ? 'كيف تلعب' : 'How to Play' }}
      </span>
      <button class="info-close" (click)="close.emit()">&#10005;</button>
    </div>

    <div class="info-body">
      <p class="how-to-play">
        {{ currLang === 'ar' ? content.howToPlayAr : content.howToPlayEn }}
      </p>

      <div class="info-section" *ngFor="let section of content.sections">
        <h4 class="section-title">
          {{ currLang === 'ar' ? section.titleAr : section.titleEn }}
        </h4>
        <ul class="section-items">
          <li *ngFor="let item of section.items">
            {{ currLang === 'ar' ? item.ar : item.en }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
